import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/userService/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { environment } from '../../../../environments/environment';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-detailinquiry',
  templateUrl: './detailinquiry.component.html',
  styleUrls: ['./detailinquiry.component.css']
})
export class DetailinquiryComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() clearEvent = new EventEmitter<void>();

  displayedProductColumns: string[] = ['BusinessVerticalName', 'BusinessCategoryName', 'ProductBrandName', 'Origin', 'Code', 'Description', 'Specified', 'Qty', 'UnitType', 'Price', 'GrossValue', 'DiscountPer', 'TotalPrice', 'VatRate', 'TotalPriceWithVat', 'Competitor', 'Remark'];

  displayedTotalColumns: string[] = ['Total', 'GrossValue1', 'DiscountRate', 'TotalPrice1', 'Vat', 'TotalPriceVat', 'blank'];

  displayedFreightColumns: string[] = ['Freight', 'FreightAmount', 'FreightRemark'];

  displayedContactColumns: string[] = ['CompanyType', 'CompanyName', 'City', 'Country', 'Email', 'Mobile', 'Website'];

  displayedTaskColumns: string[] = ['TaskId', 'TaskTitle', 'TaskDescription', 'TaskStatus', 'TaskPriority', 'StartDate', 'EndDate', 'AssignedTo', 'CreatedBy', 'CreatedDate'];

  sortContactData: any = { "column": "Business Category", "direction": "desc" };
  sortProductData: any = { "column": "CompanyName", "direction": "desc" };
  sortTaskData: any = { "column": "ProjectName", "direction": "desc" };

  registerForm: any;
  id: any;
  isCollapsed: boolean = false;

  dataSource: MatTableDataSource<any>;
  ContactDataSource: MatTableDataSource<any>;
  ProductDataSource: MatTableDataSource<any>;
  TaskDataSource: MatTableDataSource<any>;

  TotalRow: any;

  currentPage: any = 0;
  pageSize: any = 10;
  searchword: any = '';
  searchword_pro: any = '';
  searchword_Con: any = '';
  searchword_task: any = '';
  type: string;
  namesort: string;
  upicon: boolean;
  downicon: boolean;
  columnsort: string;

  formdata: any = [];
  inquiryActivityHistory: any = [];
  inquiryTask: any = [];
  inquiryContacts: any = []
  inquiryProduct: any = []
  TotalProductRecord: number = 0;
  totalProductSize: number;
  TotalContactRecord: any;
  totalContactSize: any;
  TotalTaskRecord: any;
  totalTaskSize: any;
  showMore: any;
  default: any;
  NextPageNo: any;
  loader: boolean = false;
  UpDoc: any;
  dft_icn: string;
  url: string;
  tab_id: any;
  verticalId: number;
  active: string;
  activeTab: string = "t9";
  modalRef: BsModalRef;
  filename: any;
  file: any;
  inquirydata: any;
  downloadurl: string;
  permission: any;
  userRId: any;
  t_GrossValue: any;
  t_GrossValueQAR: any;
  t_DiscountValue: any;
  t_DiscountValueQAR: any;
  t_Price: any;
  t_PriceQAR: any;
  t_VatValue: any;
  t_VatValueQAR: any;
  t_PriceWithVat: any;
  t_PriceQARWithVat: any;

  constructor(
    private formBuilder: FormBuilder,
    private UserService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private changeDetectorRefs: ChangeDetectorRef,
    private modalService: BsModalService,
  ) {
    this.activeTab = localStorage.getItem("activeId");
  }

  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Inquiry_View != 1 && this.userRId != 1) {
      this.toastr.error('You do not have permission');
      this.router.navigate(['/profile']);
    }
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace(/Ar1t/g, '=').replace(/FGH/g, '/').replace(/THD/g, '+');
    this.id = this.UserService.decryptData(decid);
    this.default = environment.showmore;
    this.dft_icn = environment.default_temp;
    this.url = environment.tempimage;
    this.downloadurl = environment.app_download_path;

    let data = {
      "InquiryId": this.id,
      "Mode": "View"
    }
    this.spinner.show();
    this.UserService.GetInquiryDetailById(data).subscribe(res => {
      this.spinner.hide();
      if (res['result'] == 'success') {
        this.formdata = res['Data'];
        this.UpDoc = res['UploadDocument'];
        this.inquirydata = res["Data"];
      }
    })

    let historydata = {
      "InquiryId": this.id,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
      "SearchWord": this.searchword,
      "Sort": this.namesort,
      "SortWise": this.type,
    }

    this.UserService.InquiryActivityHistory(historydata).subscribe(res => {
      if (res['result'] == 'success') {
        this.inquiryActivityHistory = res['Data'];
        this.showMore = res['NextPage'];
        this.NextPageNo = res['NextPageNo'];
      }
    })

    let data2 = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_pro,
      "Sort": this.namesort,
      "SortWise": this.type,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetInquiryProductByInquiryId(data2).subscribe((res) => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.currentPage = 0;
        this.inquiryProduct = res['ContactList'];
        this.ProductDataSource = new MatTableDataSource<any>(res['ContactList']);
        this.ProductDataSource.paginator = this.paginator;
        this.totalProductSize = res['TotalRecord'];

        this.TotalRow = res['TotalRow'];
        this.t_GrossValue = this.TotalRow["Total_GrossValue"];
        this.t_GrossValueQAR = this.TotalRow["Total_GrossValueQAR"];
        this.t_DiscountValue = this.TotalRow["Total_DiscountValue"];
        this.t_DiscountValueQAR = this.TotalRow["Total_DiscountValueQAR"];
        this.t_Price = this.TotalRow["Total_Price"];
        this.t_PriceQAR = this.TotalRow["Total_PriceQAR"];
        this.t_VatValue = this.TotalRow["Total_VatValue"];
        this.t_VatValueQAR = this.TotalRow["Total_VatValueQAR"];
        this.t_PriceWithVat = this.TotalRow["Total_PriceWithVat"];
        this.t_PriceQARWithVat = this.TotalRow["Total_PriceQARWithVat"];

        setTimeout(() => {
          this.TotalProductRecord = this.totalProductSize;
        }, 500);
        this.P_iterator();

      }
    })

    let data1 = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_Con,
      "sort": "",
      "SortWise": "",
      "ItemPerPages": 10,
      "PageNo": 1,
    }
    this.UserService.GetContactIdByInquiryId(data1).subscribe(res => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.currentPage = 0;
        this.inquiryContacts = res['ContactList'];
        this.ContactDataSource = new MatTableDataSource<any>(res['ContactList']);
        this.ContactDataSource.paginator = this.paginator;
        this.TotalContactRecord = res['TotalRecord'];
        this.totalContactSize = res['TotalRecord'];
        this.C_iterator();
      }
    })

    let data3 = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_task,
      "sort": "",
      "SortWise": "",
      "ItemPerPages": 10,
      "PageNo": 1,
    }

    this.UserService.GetTaskListByInquiryId(data3).subscribe(res => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.currentPage = 0;
        this.inquiryTask = res['ContactList'];
        this.TaskDataSource = new MatTableDataSource<any>(res['ContactList']);
        this.TaskDataSource.paginator = this.paginator;
        this.TotalTaskRecord = res['TotalRecord'];
        this.totalTaskSize = res['TotalRecord'];
        this.T_iterator();
      }
    })

  }

  private C_iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.inquiryContacts.slice(start, end);
    this.ContactDataSource = part;
  }

  private P_iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.inquiryProduct.slice(start, end);
    this.ProductDataSource = part;
  }

  private T_iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.inquiryTask.slice(start, end);
    this.TaskDataSource = part;
  }

  public ContacthandlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;

    this.C_iterator();
    let data = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_Con,
      "Sort": this.namesort,
      "SortWise": this.type,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1
    }
    this.UserService.GetContactIdByInquiryId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalContactRecord = res['TotalRecord'];
        this.totalContactSize = this.TotalContactRecord;
        this.spinner.hide();
        this.ContactDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  public ProducthandlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.P_iterator();
    let data2 = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_pro,
      "Sort": this.namesort,
      "SortWise": this.type,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetInquiryProductByInquiryId(data2).subscribe((res) => {
      if (res['result'] == "success") {
        this.totalProductSize = res['TotalRecord'];
        this.TotalProductRecord = this.totalProductSize;
        this.spinner.hide();
        this.ProductDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  public TaskhandlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;

    this.T_iterator();
    let data = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_task,
      "Sort": this.namesort,
      "SortWise": this.type,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetTaskListByInquiryId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalTaskRecord = res['TotalRecord'];
        this.totalTaskSize = this.TotalTaskRecord;
        this.spinner.hide();
        this.TaskDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  ContactapplyFilter() {
    this.spinner.show();
    let data = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_Con,
      "sort": "",
      "SortWise": "",
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetContactIdByInquiryId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalContactRecord = res['TotalRecord'];
        this.totalContactSize = this.TotalContactRecord;
        this.spinner.hide();
        this.ContactDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  ProductapplyFilter() {
    this.spinner.show();
    let data2 = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_pro,
      "sort": "",
      "SortWise": "",
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetInquiryProductByInquiryId(data2).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalProductRecord = res['TotalRecord'];
        this.totalProductSize = this.TotalProductRecord;
        this.spinner.hide();
        this.ProductDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  clearUserData() {
    const previousValue = this.searchword_pro;
    this.searchword_pro = '';
    if (previousValue && previousValue.length > 0 && previousValue !== this.searchword_pro) {
      this.clearEvent.emit();
    }
  }
  clearTaskData() {
    const previousValue = this.searchword_task;
    this.searchword_task = '';
    if (previousValue && previousValue.length > 0 && previousValue !== this.searchword_task) {
      this.clearEvent.emit();
    }
  }
  clearContactData() {
    const previousValue = this.searchword_Con;
    this.searchword_Con = '';
    if (previousValue && previousValue.length > 0 && previousValue !== this.searchword_Con) {
      this.clearEvent.emit();
    }
  }

  TaskapplyFilter() {
    this.spinner.show();
    let data = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_task,
      "sort": "",
      "SortWise": "",
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetTaskListByInquiryId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalTaskRecord = res['TotalRecord'];
        this.totalTaskSize = this.TotalTaskRecord;
        this.spinner.hide();
        this.TaskDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  onContactSortData(sort: Sort) {
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortContactData = [];
    this.sortContactData = { "column": sort.active, "direction": sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    }
    else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;

    let data = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_Con,
      "PageNo": this.currentPage + 1,
      "Sort": sort.active,
      "SortWise": sort.direction,
      "ItemPerPages": this.pageSize
    }
    this.UserService.GetContactIdByInquiryId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalContactRecord = res['TotalRecord'];
        this.totalContactSize = this.TotalContactRecord;
        this.spinner.hide();
        this.ContactDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  onProductSortData(sort: Sort) {
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortProductData = [];
    this.sortProductData = { "column": sort.active, "direction": sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    }
    else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    let data2 = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_pro,
      "PageNo": this.currentPage + 1,
      "Sort": sort.active,
      "SortWise": sort.direction,
      "ItemPerPages": this.pageSize
    }
    this.UserService.GetInquiryProductByInquiryId(data2).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalProductRecord = res['TotalRecord'];
        this.totalProductSize = this.TotalProductRecord;
        this.spinner.hide();
        this.ProductDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  onTaskSortData(sort: Sort) {
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortTaskData = [];
    this.sortTaskData = { "column": sort.active, "direction": sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    }
    else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    let data = {
      "InquiryId": this.id,
      "SearchWord": this.searchword_task,
      "PageNo": this.currentPage + 1,
      "Sort": sort.active,
      "SortWise": sort.direction,
      "ItemPerPages": this.pageSize
    }
    this.UserService.GetTaskListByInquiryId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalTaskRecord = res['TotalRecord'];
        this.totalTaskSize = this.TotalTaskRecord;
        this.spinner.hide();
        this.TaskDataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  show(eid) {
    let encryptid = this.UserService.encryptData(eid);
    encryptid = encryptid.toString().replace('=', 'Ar1t').replace('/', 'FGH').replace('+', 'THD');
    this.router.navigate(['/inquiry/detailinquiry-editproduct/', encryptid]);
  }

  edit(id) {
    localStorage.setItem('active_id', 'tab-selectbyid1');
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid.toString().replace('=', 'Ar1t').replace('/', 'FGH').replace('+', 'THD');
    this.router.navigate(['/inquiry/editinquiry', encryptid]);
  }

  showMoreactivity() {
    let data = {
      "InquiryId": this.id,
      "ItemPerPages": this.pageSize,
      "PageNo": this.NextPageNo,
      "SearchWord": this.searchword,
      "Sort": this.namesort,
      "SortWise": this.type,
    }
    this.loader = true;
    this.UserService.InquiryActivityHistory(data).subscribe(res => {
      this.spinner.show();
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.loader = false;
        res['Data'].forEach(element => {
          this.inquiryActivityHistory.push(element);
        });
        this.showMore = res['NextPage'];
      } else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Message']);
        this.spinner.hide();
      }
    });
  }

  tabclick(idr) {
    localStorage.setItem("activeId", idr);
  }
  tabclick2() {
    this.searchword_pro = '';
    this.ProductapplyFilter();
    this.searchword_Con = '';
    this.ContactapplyFilter();
    this.searchword_task = '';
    this.TaskapplyFilter();
  }

  AddHttpfun(value) {
    if (value) {
      if (value.startsWith("http") || value.startsWith("https")) {
        let b = value;
        window.open(b);
      }
      else {
        let a = 'http://' + value;
        window.open(a);
      }
    }
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed
  }

  downloadModal(template: TemplateRef<any>, name, data) {
    if (data) {
      this.filename = name;
      this.file = data;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  decline() {
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.file);
  }

}
